import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { MdOutlineSwapHoriz } from 'react-icons/md'

import { ResourceList } from '@/Core/UI/CrudResource'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'

import { RequestModal } from '../Components/RequestModal'
import { ErpExchangeResource, REQUEST_MODAL_STATE } from '../Resources/ErpExchangeResource'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/** Журнал обміну ERP: стандартна колекція ресурсу + вікно перегляду запиту */
const IndexPage = observer(() => {
    const listContext: any = useMemo(
        () =>
            createCrudResourceContext({
                contextType: 'list',
                registryKey: 'Setting.ErpExchange.list',
                resource: ErpExchangeResource,
            } as any),
        []
    )

    const requestRecord: Record<string, any> | null = listContext.states?.[REQUEST_MODAL_STATE] ?? null

    return (
        <>
            <ResourceList crudContext={listContext} registryKey="Setting.ErpExchange.list" />
            <RequestModal record={requestRecord} onClose={() => listContext.setState(REQUEST_MODAL_STATE, null)} />
        </>
    )
})

export const pageConfig: IPageConfig = {
    key: 'Setting.ErpExchange',
    route: '/settings/erp-exchange',
    title: 'Журнал обміну ERP',
    icon: <MdOutlineSwapHoriz />,
}

export default IndexPage
